import React from 'react';
import '../../../../components/pages/groups/group-container/main-table/style.css'
import {StatsItems} from "components/pages/stats/stats-table/stats-items/StatsItems";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {CustomPagination} from "components/pagination/CustomPagination";
import {useAppDispatch, useAppSelector} from "common/hook";
import {StatisticsItem} from "features/model/types/hr/getStatistics";
import {getStatistics} from "features/model/service/hr/get-statistics/getStatistics";


export const StatsTable = () => {
    const statisticsData = useAppSelector(state => state.statistics)
    const dispatch = useAppDispatch()
    const {isLoading, success, data} = statisticsData
    const {pageCount, pageSize, page} = data.pagination


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(getStatistics({page: value - 1}));
    };

    return (
        <div className="data-tbl no-btn-link-col statistic-tbl">
            <div className="row thead">
                <div className="col student-col">Студент <span>{data.count}</span></div>
                <div className="col radial-stat-col center">Эффективность</div>
                <div className="col radial-stat-col center">Посещаемость</div>
                <div className="col center">Домашнее задание</div>
                <div className="col center">Последний срез</div>
            </div>

            {isLoading ? (
                <Preloader/>
            ) : data.items && data.items.length > 0 ? (
                data.items.map((item: StatisticsItem,index) => (
                    <StatsItems key={index} item={item}/>
                ))
            ) : (
                <NothingYetMessage/>
            )}

            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} currentPage={page + 1} onChangeHandle={onChangeHandle}/>
            )}

        </div>
    );
};
